<template>
  <div v-if="loading" class="center-text">
    <loader-vue color="black" />
    <div v-text="$t('generic.loading')"></div>
  </div>
  <div v-else>
    <h4 class="container header ml20 hidden-mobile">
      {{ $t('components.menuOptions.fileUploads') }}
    </h4>
    <div class="container center-text" data-cy="uploadfile-mobile-button">
      <s-button
        @click="triggerFileInput"
        :safe="true"
        :loading="saveLoading"
        :small="true"
        >{{ $t('generic.uploadFile') }}</s-button
      >
    </div>
    <div class="container">
      <h2
        class="sub-header full-width hidden-desktop mb-5"
        v-text="$t('views.fileUploads.myFileUploads')"
      ></h2>
      <template v-for="(patientUpload, index) in sortedUploads" :key="index">
        <info-row-patient-upload
          :patient-upload="sortedUploads[index]"
          :remove-function="() => deletePatientFileUpload(patientUpload.Id)"
        />
      </template>
      <div>
        <div class="row">
          <div class="col s12 md1">
            <div>
              <input
                type="file"
                ref="files"
                accept="image/png, image/jpeg, application/pdf"
                @change="setupFiles"
                @click="resetFileInput"
                style="display: none"
              />
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>

    <!-- Study task info modal -->
    <modal-study-task-vue
      v-if="$activeStudyTask"
      :show="$showStudyTaskModal && $activeStudyTask?.hasModalContent"
      :study-task="$activeStudyTask"
      @closed="$setShowStudyTaskModal(false)"
    ></modal-study-task-vue>
  </div>
</template>

<script>
import moment from 'moment';
import { sortBy } from 'lodash';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
  STUDY_TASK_ACTIONS,
  STUDY_TASK_GETTERS,
  STUDY_TASK_MUTATIONS
} from '@/store/modules/studytasks';
import InfoRowPatientUpload from '@/views/components/InfoRow/InfoRowPatientUpload.vue';
import PatientFileUploadService from '@/Services/PatientFileUpload/PatientFileUploadService';
import PatientFileUploadModel from '@/Models/PatientFileUploadModel';
import LoaderVue from '@views/components/Loader.vue';
import ModalStudyTaskVue from '@views/components/Modals/ModalStudyTask.vue';

export default {
  components: {
    InfoRowPatientUpload,
    LoaderVue,
    ModalStudyTaskVue
  },
  props: {},
  data() {
    return {
      saveLoading: false,
      patientUploads: [],
      loading: false
    };
  },
  beforeRouteLeave(to, from, next) {
    // TODO: Handle case where we go to next study task.
    this.$clearActiveStudyTask();
    next();
  },
  mounted() {
    this.GetMyPatientFileUploads();
    this.$getActiveStudyTask(); // In case user has reloaded the page.

    if (this.$activeStudyTask) {
      this.$setShowStudyTaskModal(true);
    }
  },
  computed: {
    ...mapGetters('studytasks', {
      $activeStudyTask: STUDY_TASK_GETTERS.ACTIVE_STUDY_TASK,
      $showStudyTaskModal: STUDY_TASK_GETTERS.SHOW_STUDY_TASK_MODAL
    }),
    sortedUploads() {
      return sortBy(this.patientUploads, x => moment(x.CreatedDate)).reverse();
    }
  },
  methods: {
    ...mapActions('studytasks', {
      $getActiveStudyTask: STUDY_TASK_ACTIONS.GET_ACTIVE_STUDY_TASK,
      $clearActiveStudyTask: STUDY_TASK_ACTIONS.CLEAR_ACTIVE_STUDY_TASK,
      $getMyNextStudyTask: STUDY_TASK_ACTIONS.GET_MY_NEXT_STUDY_TASK
    }),
    ...mapMutations('studytasks', {
      $setShowStudyTaskModal: STUDY_TASK_MUTATIONS.SET_SHOW_STUDY_TASK_MODAL
    }),
    deletePatientFileUpload(uploadId) {
      return PatientFileUploadService.deleteMyPatientFileUpload(uploadId).then(
        () => {
          var index = this.patientUploads.findIndex(x => x.Id === uploadId);
          this.patientUploads.splice(index, 1);
        }
      );
    },
    savePatientFileUpload(newPatientUpload) {
      this.saveLoading = true;
      return PatientFileUploadService.CreateMyPatientFileUpload(
        newPatientUpload
      )
        .then(patientUpload => {
          this.$bus.$emit('toast.display', {
            message: this.$root.$t('generic.saveSuccess'),
            status: 'success'
          });
          this.patientUploads.push(patientUpload);
        })
        .catch(error => {
          if (error.Message) {
            this.error = error.Message;
          } else {
            this.error = this.$root.$t('errors.noResponse');
          }
          this.$bus.$emit('toast.display', {
            message: this.error,
            status: 'failure'
          });
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    GetMyPatientFileUploads() {
      this.loading = true;
      return PatientFileUploadService.getMyPatientFileUploads().then(
        PatientFileUploads => {
          this.patientUploads = PatientFileUploads;
          this.loading = false;
        }
      );
    },
    triggerFileInput() {
      this.$refs.files.click();
    },
    resetFileInput() {
      this.$refs.files.value = '';
    },
    async setupFiles() {
      const control = this.$refs.files;
      const files = control.files;
      const file = files[0];
      const newPatientFileUpload = new PatientFileUploadModel({
        FileName: file.name,
        MimeType: file.type
      });
      const reader = new FileReader();
      reader.readAsDataURL(file, 'UTF-8');
      reader.onload = evt => {
        const base64 = evt.target.result;
        newPatientFileUpload.Data = base64;
        this.savePatientFileUpload(newPatientFileUpload);
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
